import { AsyncState, httpResult, HttpResult, loadingAsyncState, Unit } from "widgets-for-react";
import { ContactUsState } from './contactUs.state'

export const submitContactUs = (contactUsState: ContactUsState): AsyncState<Unit> =>
  loadingAsyncState(() =>
    new Promise((res, rej) => setTimeout(() => res(httpResult.success({})))))